import React from 'react'
import { connect } from 'react-redux'
import { getListItems, changeListItem, nullDate } from 'tyan/public/utility'
import { hasChangedValues, getFormValue, changeItemsValue } from 'tyan/public/utility/formValues'
import AddInstrumentInfo from './AddInstrumentInfo'
import PurchaseDiv from './PurchaseDiv'
import { exportFile } from 'tyan/public/index'
class AssetAccDiv extends React.Component {
	state = {
	}

	componentDidMount = () => {
		const { id } = this.props
		this.handlerInitValue(id)
	}

	handlerInitValue = (id) => {
		Tyan.doPostEvent({
			event: 'GetAssetAcc',
			data: { id },
			onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
				}
			}
		})
	}

	handlerSave = (assetAccInfo) => {
		if (getFormValue(this, '基本信息', '安装调试结束日期') < getFormValue(this, '基本信息', '安装调试开始日期')) {
			Ext.toast("安装调试结束日期不能小于安装调试开始日期"); return
		}
		const { id, changedValues基本信息 } = this.state
		Tyan.doPostEvent({
			event: 'SaveAssetAcc',
			data: { id, assetAccInfo, changedValues基本信息 },
			onEnd: ({ errorMessage, id }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					Ext.toast('保存成功')
					this.setState({ id })
					this.handlerInitValue(id)
				}
			}
		})
	}
	handlerAdd = (assetAccInfoID) => {
		const { id, changedValues基本信息 } = this.state
		Tyan.doPostEvent({
			event: 'AddAssetAccInfo',
			data: { id: assetAccInfoID },
			onEnd: ({ errorMessage }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					Ext.toast('添加成功')
					this.handlerInitValue(id)
				}
			}
		})
	}

	handlerDelete = () => {
		const { id } = this.state
		const { onSave, onClose } = this.props
		Tyan.pubForm.showConfirm('确定要删除？', () =>
			Tyan.doPostEvent({
				event: 'DeleteAssetAcc',
				data: { id },
				onEnd: ({ errorMessage }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					}
					else {
						Ext.toast('删除成功')
						onSave && onSave()
						onClose && onClose()
					}
				}
			}))
	}

	handlerDeleteInfo = (id) => {
		this.handlerSave('')
		const { id: reqAssetAccID } = this.state
		Tyan.doPostEvent({
			event: 'DeleteAssetAccInfo',
			data: { id },
			onEnd: ({ errorMessage }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					Ext.toast('删除成功')
					this.handlerInitValue(reqAssetAccID)
				}
			}
		})
	}

	bChanged = () => {
		return hasChangedValues(this)
	}

	canSave = () => {
		const 状态 = getFormValue(this, '基本信息', '状态')
		const 资产明细附件 = getFormValue(this, '基本信息', '资产明细附件')
		var bSave = false
		if (状态 == '财务经办签核') {
			if (资产明细附件 && 资产明细附件.length > 0) {
				bSave = false
			} else {
				bSave = true
			}
		}
		return bSave
	}

	handlerClose = () => {
		const { onClose } = this.props
		if (!this.bChanged()) {
			onClose && onClose()
			return
		}
		Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
	}

	handlerGetInstrumentInfo = (id, instrumentID) => {
		Tyan.pubForm.showDialog('设备信息', props => <AddInstrumentInfo {...props} id={instrumentID} assetAccInfoID={id} onSave={() => this.handlerInitValue(this.props.id)} />)

	}

	handlerAsseAccPrint = () => {
		const { id } = this.state
		exportFile(null, null, "AssetAccPrint?id=" + id)
	}

	handlerGetPurchaseID = (id) => {
		const 采购申请单号 = getFormValue(this, '基本信息', `资产明细[${id}].采购申请单号`)
		Tyan.doPostEvent({
			event: 'GetPurchaseID',
			data: { 采购申请单号 },
			onEnd: ({ errorMessage, id }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				Tyan.pubForm.showDialog('采购信息', props => <PurchaseDiv {...props} id={id} noEdit={false} />)
			}
		})

	}

	fieldset基本信息 = () => {
		const 状态 = getFormValue(this, '基本信息', '状态')
		const readOnly = this.props.readOnly || false
		const s = { margin: '5px 15px 5px 15px', minWidth: 150, flex: 1 }
		const { list } = getListItems(this, '基本信息', '资产明细')
		var _fieldset = [
			{ _text: '申请单号', minWidth: '45%', disabled: true },
			{ _text: '申请人', minWidth: '45%', disabled: true },
			{ _text: '申请部门', minWidth: '45%', disabled: true },
			{ _date: '申请时间', minWidth: '45%', disabled: true },
			{ _date: '安装调试开始日期', minWidth: '45%', },
			{ _date: '安装调试结束日期', minWidth: '45%', },
			// { _text: '验收说明', minWidth: '90%', maxRows: 3 },
			{ _files: '附件', minWidth: '90%', disabled: 状态 !== '申请中' },
			{ _files: '资产明细附件', minWidth: '80%', required: 状态 == '财务经办签核', disabled: 状态 !== '财务经办签核' },
			{
				_group: '', minWidth: '45%', margin: 0, padding: 0, items: [
					{ _label: '', minWidth: '80%', margin: 0, padding: 0, },
					{
						_buttons: [
							{ _button: '添加...', ui: '', handler: () => this.handlerSave('新增资产明细'), hidden: readOnly || 状态 !== '申请中', },
						], width: 100, margin: 0, padding: 0
					},
				]
			},
		]
		var iNum = 0
		list.forEach((o, iNo) => {
			const { list: list1 } = getListItems(this, '基本信息', `资产明细[${o.id}].资产明细`)
			var _items = []
			_items.push({
				_group: '', margin: '5 0 5 0', minWidth: '90%', items: [
					{ _label: '资产编号', ...s, cdt: () => !['申请中', '课长签核', '部长签核', '处长签核'].includes(状态) },
					{ _label: '产品序列号', ...s, },
					{ _label: '验收结果', ...s, },
					{ _label: '资产保管人', ...s, },
					{ _label: '附属设备', ...s, },
					{ _label: '存放地点', ...s, },
					{
						_buttons: [
							{ _button: '添加...', ui: '', margin: '0px 15px 0px 0px', handler: () => this.handlerAdd(o.id), hidden: readOnly || 状态 !== '申请中', },
						], width: '101px', margin: 0
					},]
			})
			list1.forEach((p, iNo) => {
				const _list = { listName: '资产明细', id: p.id }
				_items.push({
					_group: '', list: _list, margin: '5 0 5 0', minWidth: '90%', items: [
						{ _text: '', name: '资产编号', ...s, required: true, disabled: 状态 !== '采购人签核' || readOnly, cdt: () => !['申请中', '课长签核', '部长签核', '处长签核'].includes(状态) },
						{ _text: '', name: '产品序列号', ...s, },
						{ _select: '', name: '验收结果', ...s, optionName: '验收结果' },
						{ _text: '', name: '资产保管人', ...s, },
						{ _text: '', name: '附属设备', ...s, },
						{ _text: '', name: '存放地点', ...s, },
						{
							_buttons: [
								{
									_button: '删除', icon: 'trash-o', ui: 'decline', margin: 0, hidden: readOnly || 状态 !== '申请中',
									handler: () => Tyan.pubForm.showConfirm('确定要删除？', () => { this.handlerDeleteInfo(p.id) }),
								},
								{
									_button: `${p.instrumentID > 0 ? '查看设备...' : '添加设备...'}`, ui: '', margin: 0,
									handler: () => this.handlerGetInstrumentInfo(p.id, p.instrumentID), cdt: () => 状态 == '设备信息录入',
								},
							], width: '101px', margin: 0, padding: 0,
						},
					]
				})
			})
			iNum++
			const _list = { listName: '资产明细', id: o.id }
			_fieldset.push({
				_border: iNum == 0 ? '资产明细' : `资产明细${iNum}`, margin: iNum == 1 ? 0 : '20 0 5 0', minWidth: '90%', list: _list,
				items: [
					{ _text: '物料名称', minWidth: '45%', disabled: o.申请人验收明细ID != 0 || readOnly || 状态 !== '申请中' },
					{ _text: '规格型号', minWidth: '45%', disabled: o.申请人验收明细ID != 0 || readOnly || 状态 !== '申请中' },
					//{ _text: '采购申请单号', minWidth: '45%', disabled: true },
					o.申请人验收明细ID != 0 ?
						{
							_group: '', minWidth: '45%', margin: 0, items: [
								{ _text: '采购申请单号', minWidth: '20%', disabled: true },
								{
									_buttons: [
										{
											_button: '', icon: 'search', ui: '', margin: 0,
											handler: () => this.handlerGetPurchaseID(o.id),
										},
									], width: 100, margin: 0,
								},
							]
						} : { _text: '采购申请单号', minWidth: '45%', disabled: o.申请人验收明细ID != 0 || readOnly || 状态 !== '申请中' },
					{ _text: '供应商', minWidth: '45%', disabled: o.申请人验收明细ID != 0 || readOnly || 状态 !== '申请中' },
					{ _text: '单位', minWidth: '45%', disabled: o.申请人验收明细ID != 0 || readOnly || 状态 !== '申请中' },
					{ _text: '验收数量', minWidth: '45%', disabled: true },
					{ _select: '币别', minWidth: '45%', forceSelection: false, disabled: o.申请人验收明细ID != 0 || readOnly || 状态 !== '申请中' },
					{ _float: '资产原值', name: '本币未税金额', minWidth: '45%', disabled: o.申请人验收明细ID != 0 || readOnly || 状态 !== '申请中' },
					{ _text: '采购意见', minWidth: '90%', maxRows: 3, disabled: 状态 !== '采购人签核' || readOnly },
					{ _group: '', margin: '5 0 5 0', minWidth: '90%', items: _items }
				]
			})
			//iNum++
		})

		return _fieldset
	}

	fieldset流转日志 = () => {
		return [
			{ _html: '', name: '流转日志', minWidth: '95%', style: { textAlign: 'left' } }]
	}

	fieldset签核流程 = () => {
		return [
			{ _html: '', name: '签核流程', minWidth: '95%', style: { textAlign: 'left' } }]
	}

	render() {
		const { showMessage: Message, showBody: Body, readOnly } = this.props
		const { initValues基本信息, changedValues基本信息, id } = this.state
		if (!initValues基本信息) return <Message text={'请稍等 ...'} />
		const { 状态, 提交时间 } = initValues基本信息
		return <Body data={this} maxWidth="100%"
			controls={
				readOnly ? [
					{ _button: '打印凭证', icon: 'print', handler: this.handlerAsseAccPrint, cdt: () => id > 0 && 状态 == '已完成', },
					{ _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
				]
					: [
						{ _flow: 'AssetAccFlow', disabled: this.bChanged() || this.canSave(), cdt: () => id > 0, },
						{ _button: '打印凭证', icon: 'print', handler: this.handlerAsseAccPrint, cdt: () => id > 0 && 状态 == '已完成', },
						{ _button: '保存', icon: 'save', handler: () => this.handlerSave(''), disabled: !(this.bChanged()), cdt: () => 状态 == '申请中' || 状态 == '采购人签核' || 状态 == '财务经办签核' },
						{ _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0 && 状态 == '申请中' && 提交时间 == nullDate, handler: this.handlerDelete, disabled: this.bChanged() },
						{ _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
					]}
			fieldsets={
				[
					{ title: '基本信息', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: readOnly || 状态 !== '申请中' },
					{
						_fieldsets: [
							{ title: '流转日志', name: '基本信息', _fieldset: this.fieldset流转日志(), fullblock: true },
							{ title: '签核流程', name: '基本信息', _fieldset: this.fieldset签核流程(), fullblock: true },
						], docked: 'right', width: '35%',
					}
				]}
		/>
	}
}

export default connect()(AssetAccDiv)